import { FC, useContext } from 'react'
import { updateCreatePost, useAppDispatch, useAppSelector } from '../../../../redux'
import { conditionalStage, hydrateSocialProfiles, userStore } from '../../../../utils'
import { StyledCreateInstagramPostType } from '.'

const CreateInstagramPostType: FC = () => {
  const dispatch = useAppDispatch()
  const { user } = useContext(userStore)
  const { post } = useAppSelector((state) => state.create)

  const profiles = hydrateSocialProfiles(post?.socialProfiles, user)
  const hasInstagram = profiles.some((profile) => profile.type === 'instagram')

  if (!hasInstagram) {
    return null
  }

  const options = [
    {
      label: 'Feed',
      value: 'feed' as const
    },
    ...conditionalStage((post?.media?.length || 0) < 2, [
      {
        label: 'Reel',
        value: 'reel' as const
      },
      {
        label: 'Story',
        value: 'story' as const
      }
    ])
  ]

  return (
    <StyledCreateInstagramPostType>
      <span className="input-label">Instagram Post Type</span>
      <div className="post-type-buttons">
        {options.map((option) => (
          <button
            key={option.value}
            className={
              post?.instagramPublishType === option.value ||
              (!post?.instagramPublishType && option.value === 'feed')
                ? 'active'
                : ''
            }
            onClick={() => dispatch(updateCreatePost({ instagramPublishType: option.value }))}
          >
            {option.label}
          </button>
        ))}
      </div>
    </StyledCreateInstagramPostType>
  )
}

export default CreateInstagramPostType
